import { MixedEvent, ParcelEvent } from '@pperform/pp-data-mappers';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'components/Tooltip';
import { TRACKING_EVENT_ANALYTICS } from '../TrackingTimeline.constant';
import { IssueIcon } from '../TrackingTimeline.styles';

interface EventIssueProps {
  event: MixedEvent | ParcelEvent;
}

export const EventIssue = ({ event }: EventIssueProps): JSX.Element => {
  const { t } = useTranslation();

  if (!event.eventTypeMasterData) {
    return null;
  }

  if (event.eventTypeMasterData.analytics === TRACKING_EVENT_ANALYTICS.regular)
    return null;

  const tooltipId = `event-issue-tooltip-${event.id}`;

  return (
    <>
      <IssueIcon
        role="img"
        tabIndex={0}
        data-tooltip-id={tooltipId}
        data-testid={tooltipId}
      />
      <Tooltip
        id={tooltipId}
        render={() => (
          <div id={`issue-tooltip-content-${event.id}`}>
            <span className="sr-only">{t('ALT_TEXT_ISSUE_ICON')}</span>
            <span>{t(event.eventTypeMasterData.delayExceptionSource)}</span>
          </div>
        )}
      />
    </>
  );
};
